export default {
    book: "Foglalás",
    age_limit: "Korhatár: Csak ({age}) felett",
    change_plan: "Terv módosítása",
    upgrade_product: "Módosítsa foglalását magasabb kategóriába",
    upgrade: "Frissítés",
    cancel_upgrade: "Frissítés megszakítása",
    choose_product: "Válasszon terméket",
    days: "{count} Nap | {count} napok",
    login_register: "Bejelentkezés/Regisztráció",
    current: "Jelenlegi",
    keyless_benefits: {
        label: 'Címke: egyenesen az autóhoz {0}',
        highlight: 'Kiemelés: Bérlési szolgáltatás',
        list: {
            cant_lose_the_key: 'Nem veszítheti el a kulcsot:  Teljes körű biztosítás',
            zero_excess: 'Önrész nélkül',
            phone_as_a_key: 'Telefon mint kulcs: telefon mint kulcs',
            straight_to_car: 'Egyenesen az autóhoz: Várakozás nélkül',
            no_queues: 'Sorbanállás nélkül',
            online_id_check: 'Online ID ellenőrzés',
            self_checkout: 'Önálló gépkocsi felvétel',
        },
    },
}
